/// <reference path="./FormItem.ts" />
namespace HA.Core.HTML.Form {
    //noinspection TsLint
    export class Select extends FormItem {

        public reset(): Select {
            this.replaceItems([]);
            return this;
        }

        /**
         *
         * @param items
         */
        public replaceItems(items: any[]): void {
            this.getEntries().replaceItems(items);
            const t = this.findByAttribute("counter");
            t.setText(items.length + "/" + this.getChoicesLength());
        }

        /**
         *
         * @returns {Array}
         */
        public getSelected() {
            return this.getEntries().getValues();
        }

        public getType(): string {
            return "Select";
        }

        /**
         * @returns {Map<any, any>}
         */
        public getChoices() {
            const r = new Map();
            const tag = this.findByAttribute("info");
            let choices = tag.getAttribute("choices");

            if (choices) {
                choices = JSON.parse(choices);
                const me = this;
                choices.forEach((c: any) => {
                    r.set(c, toMap({v: c, s: me.isSelected(c)}));
                });
            }

            return r;
        }

        protected getChoicesLength(): number {
            const tag = this.findByAttribute("info");
            const max = tag.getAttribute("max");
            if (max && max !== "undefined") {
                return max;
            }
            const choices = tag.getAttribute("choices");

            if (choices) {
                return JSON.parse(choices).length;
            }

            return 0;
        }

        protected isSelected(value: any) {
            let r = false;
            this.getEntries().getItems().forEach((e: SelectEntry) => {
                if (e.equals(value)) {
                    r = true;
                    return;
                }
            });

            return r;
        }

        protected getEntries(): List {
            return this.get("entries");
        }

        protected initialize(data: any) {
            super.initialize(data);
            this.addToData("entries", new List({
                entryClass: SelectEntry,
                itemTagClass: this.getItemTagClass(),
                tag: this.findByAttribute("ic"),
            }));
            const me = this;
            if (this.has("trans")) {
                const selected: any[] | null = this.translate("#" + this.get("name"));

                if (selected && selected.length > 0) {
                    selected.forEach((i: any) => {
                        if (!i || i === "") {
                            return;
                        }
                        me.add(i);
                    });
                }
            }
        }

        protected add(item: any) {
            this.getEntries().addItem(item);
        }

        protected getItemTagClass() {
            return TextItemEntry;
        }

        private getMax(): number {
            return parseInt(this.getAttr("max"));
        }

        protected createSelf(): void {
            const c = this.createItemTag({
                attributes: [
                    {n: "ft", v: this.get("ft")},
                ],
                c: [
                    {
                        attributes: [
                            {n: "ic", v: 1},
                        ],
                        class: "fwrap",
                        t: "fc",
                    }],
                class: "itemsbox",
                t: "div",
            });

            this.setElement(c.getElement());
        }
    }
}
